import { useState } from 'react'

/**
 * A DOM node that keeps its content mounted while it moves around the page. Render the content into it with
 * `createPortal(content, node)` from somewhere that stays mounted, and place it with a `MovableSlot`
 * (`components/watch/Movable`). The watch screen uses it to move the camera strip, the map and the chat between the
 * desktop's columns and the phone's tabs: React state, live video elements and the Mapbox instance all stay put; only
 * their node changes parent.
 */
export function useMovableNode(className?: string, id?: string): HTMLDivElement {
  const [node] = useState(() => {
    const div = document.createElement('div')
    if (className) div.className = className
    if (id) div.id = id
    return div
  })
  return node
}
